<template>
    <div>
        <Form :model="formData" :label-width="120" ref="form">
            <FormItem label="最晚确认时间" :rules="required" prop="lastConfirmDate">
                <DatePicker style="width:100%" type="date" v-model="formData.lastConfirmDate" :value="formData.lastConfirmDate" :options="dateOptions" format='yyyy-MM-dd' @on-change="handleChange"></DatePicker>
            </FormItem>
            <FormItem label="备注">
                <Input v-model="formData.remark" type="textarea" placeholder="请输入修改原因" :rows="4"/>
            </FormItem>
        </Form>
        <div style="color: red; padding: 5px 25px;" v-html="$t('fbb.planmanage.change_confirm_time',{defaultValue:'修改最晚确认时间'})"></div>
        <div class="text-right margin-bottom-15">
            <Button type="primary" @click="submit">确定</Button>
            <Button class="margin-left-10" @click="cancel">取消</Button>
        </div>
    </div>
</template>

<script>
import { HttpChangeTime } from '@/service/salesreturns';
export default {
    props:['ids'],
    components: {
		// compUpload: () => import("@components/templates/upload"),
	},
    data(){
        return {
            formData:{
            },
            required: [{
                required: true,
                message: this.$t('global.common.fill_requiredd',{defaultValue:'该信息不能为空,请填写'})
            }],
            dateOptions: {
                disabledDate (date) {
                    return date && date.valueOf() < Date.now() - 86400000;
                }
            },
        }
    },
    methods:{
        handleChange(date){
            this.formData.lastConfirmDate = date
        },
        async submit(){
            let valid = await this.$refs['form'].validate();
            if (!valid) return;
            let ids = this.ids.split(',').map(item=>{
                return parseInt(item)
            })
            // 保存并新增
            HttpChangeTime({
                ids: ids,
                ...this.formData
            }).then(res=>{
                this.$Message.success({
                    content:res.message,
                    duration:10,
                    closable:true,
                })
                this.cancel()
            },err=>{
                this.$Message.error({
                    content:err.message,
                    duration:10,
                    closable:true,
                })
            })
        },
        cancel(){
            this.$emit("on-update");
            this.$emit('on-close')
        },
    },
}
</script>
